<template>
  <section>
    <v-list v-if="hasCategories" nav dense>
      <v-subheader>{{ $translate('CATEGORIES') }}</v-subheader>
      <v-list-item
        v-for="(category, categoryIndex) in productCategories"
        :key="`category-${categoryIndex}`"
        @click="onCategoryClick(category)"
      >
        <v-list-item-avatar size="35">
          <v-img :src="category.PictureUrl" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-subtitle>
            {{ category.Name }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider />
  </section>
</template>

<script>
import { addLog } from '@/api/dssRequest';

export default {
  name: 'HeaderCategoriesMobile',
  emits: ['close-menu'],
  computed: {
    productCategories() {
      return this.$store.getters['user/productCategories'];
    },
    hasCategories() {
      return (
        this.productCategories != null && this.productCategories.length > 0
      );
    },
  },
  methods: {
    onCategoryClick(category) {
      this.$store.commit('setCurrentDetailsForEventPage', {});
      this.$store.commit('setCurrentDetailsForEventPage', {
        Type: 'ProductCategory',
        Id: category.Id,
        Description: category.Description,
        Name: category.Name,
        Picture: category.PictureUrl,
      });

      addLog(
        this.$store.getters['auth/userName'],
        category.Id,
        'ProductCategory',
        'Home',
        -1
      );

      this.$emit('close-menu');

      this.$router.push({
        name: 'ProductCategory',
        params: {
          event_id: category.EventId,
          category_id: category.Id,
        },
      });
    },
  },
};
</script>
